// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminPurchaseOrders = (client) => ({
    /**
     * `POST /admin/purchase-orders/:id/approve`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminPurchaseOrdersIdApproveCreate
     * @source packages/medusa-plugin-po-payment-v2/src/api/admin/purchase-orders/[id]/approve/route.ts
     */
    approve: (id, body, query, headers) => client.fetch(buildPath("/admin/purchase-orders/:id/approve", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /admin/purchase-orders/:id/cancel`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminPurchaseOrdersIdCancelCreate
     * @source packages/medusa-plugin-po-payment-v2/src/api/admin/purchase-orders/[id]/cancel/route.ts
     */
    cancel: (id, body, query, headers) => client.fetch(buildPath("/admin/purchase-orders/:id/cancel", [id]), { method: "POST", body, query, headers }),
    /**
     * `GET /admin/purchase-orders`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminPurchaseOrdersList
     * @source packages/medusa-plugin-po-payment-v2/src/api/admin/purchase-orders/route.ts
     */
    list: (query, headers) => client.fetch("/admin/purchase-orders", { method: "GET", query, headers }),
    /**
     * `POST /admin/purchase-orders/:id/refund`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminPurchaseOrdersIdRefundCreate
     * @source packages/medusa-plugin-po-payment-v2/src/api/admin/purchase-orders/[id]/refund/route.ts
     */
    refund: (id, body, query, headers) => client.fetch(buildPath("/admin/purchase-orders/:id/refund", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /admin/purchase-orders/:id/reject`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminPurchaseOrdersIdRejectCreate
     * @source packages/medusa-plugin-po-payment-v2/src/api/admin/purchase-orders/[id]/reject/route.ts
     */
    reject: (id, body, query, headers) => client.fetch(buildPath("/admin/purchase-orders/:id/reject", [id]), { method: "POST", body, query, headers }),
    /**
     * `GET /admin/purchase-orders/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminPurchaseOrdersIdGet
     * @source packages/medusa-plugin-po-payment-v2/src/api/admin/purchase-orders/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/admin/purchase-orders/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /admin/purchase-orders/:id/document/signed-url`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminPurchaseOrdersIdDocumentSignedUrlGet
     * @source packages/medusa-plugin-po-payment-v2/src/api/admin/purchase-orders/[id]/document/signed-url/route.ts
     */
    retrieveDocumentSignedUrl: (id, query, headers) => client.fetch(buildPath("/admin/purchase-orders/:id/document/signed-url", [id]), { method: "GET", query, headers }),
    /**
     * `PUT /admin/purchase-orders/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminPurchaseOrdersIdUpdate
     * @source packages/medusa-plugin-po-payment-v2/src/api/admin/purchase-orders/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/admin/purchase-orders/:id", [id]), { method: "PUT", body, query, headers }),
    /**
     * `POST /admin/purchase-orders/:id/convert`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminPurchaseOrdersIdConvertCreate
     * @source packages/medusa-plugin-po-payment-v2/src/api/admin/purchase-orders/[id]/convert/route.ts
     */
    updateConvert: (id, body, query, headers) => client.fetch(buildPath("/admin/purchase-orders/:id/convert", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /admin/purchase-orders/:id/mark-paid`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminPurchaseOrdersIdMarkPaidCreate
     * @source packages/medusa-plugin-po-payment-v2/src/api/admin/purchase-orders/[id]/mark-paid/route.ts
     */
    updateMarkPaid: (id, body, query, headers) => client.fetch(buildPath("/admin/purchase-orders/:id/mark-paid", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=purchase-orders.js.map